<template>
  <div>
    <div id="header-container" class="px-5 in-step">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header" />
      <div class="pt-4 text-white">
        <h3 class="text-white">{{ $t("Add Recipient") }}</h3>
        <span class="fz-16 fw-400">Fill out the form to create recipient</span>
      </div>

      <step-container :current_step="1" :step_list="stepList" class="mt-3"></step-container>
    </div>

    <b-container fluid class="mt-0 pb-5">
      <div id="body-container" class="px-4 pt-3">
        <b-row>
          <b-col cols="12">
            <h5 class="mb-4">Recipient Info</h5>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label>{{ $t("Merchant Number") }} <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="params.userNo" @keyup="onChange('userNo')" />
              <div v-if="error['userNo']" class="invalid-feedback d-block mb-3">
                {{ $t(error["userNo"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label>{{ $t("User Account Name") }}
                <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="params.enName" @keyup="onChange('enName')" />
              <div v-if="error['enName']" class="invalid-feedback d-block mb-3">
                {{ $t(error["enName"]) }}
              </div>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="form-group mb-3">
              <label>{{ $t('Swift Code') }} <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="params.swiftCode" @keyup="onChange('swiftCode')" />
              <div v-if="error['swiftCode']" class="invalid-feedback d-block mb-3">
                {{ $t(error['swiftCode']) }}
              </div>
            </div>
          </b-col>

          <b-col>
            <b-row class="pb-5">
              <b-col cols="12">
                  <label>{{ $t('Supporting Document') }} <span class="text-danger">*</span></label>
                  <span class="position-relative">
                      <button type="button" class="flat-button position-absolute" @click="togglePopup()">
                          <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                      </button>
                  </span>
                  <NewPopupInfo :name="'voucher'" v-if="showPopup"></NewPopupInfo>
              </b-col>

              <b-col cols="12" class="mb-5">
                  <FileUploader :type="'browse'" :ref="'document'" :allowed_types="['pdf','doc','docx','rar','zip']" :size="10 * 1024 * 1024"
                      @capture-file="captureFile($event)" @remove-image="removeImage($event)">
                  </FileUploader>
                  <div v-if="error['image']" class="invalid-feedback d-block mb-3">
                      {{ $t(error['image']) }}
                  </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="mb-5 mt-5">
          <b-col cols="12" class="d-flex">
            <button @click="$router.go(-1)" class="btn btn-previous d-block mr-auto">
              {{ $t("Previous") }}
            </button>
            <button @click="doSubmit" class="btn btn-primary d-block">
              {{ $t("Submit") }}
            </button>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import LoaderComponent from "@/components/LoaderComponent";
import FileUploader from '@/components/Kyc/FileUploader.vue';
import stepContainer from "@/components/CardManagement/stepContainer";
import NewPopupInfo from '@/components/NewPopupInfo.vue';
import CreateAccount from '@/services/CreateAccount';

export default {
  name: "add-recipient",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isLoading: false,
      showPopup: false,
      accountId:'',
      userNo:'',
      fileId:'',
      optional: [],
      stepList: ["Recipient Info", "Recipient Summary"],
      params: {
        image: '',
        userNo: "",
        enName: "",
        swiftCode: '',
      },
      error: {
        image: '',
        userNo: "",
        enName: "",
        image: '',
        swiftCode: '',
      },
    };
  },
  components: {
    LoaderComponent,
    stepContainer,
    FileUploader,
    NewPopupInfo
  },
  methods: {
    onChange(key) {
      this.error[key] = "";
    },
    validate() {
      let success = true;
      let self = this;

      Object.keys(this.params).forEach(function (key) {
        if (!self.params[key] && !self.optional.includes(key)) {
          console.log(key+" can not be blank.")
          self.error[key] = "can not be blank.";
          success = false;
        }
      });
      console.log("success : "+success);

      return success;
    },
    doUpload(){
      let self = this;
      if (this.params.image) {
        this.isLoading = true;
        CreateAccount.uploadFile({
            "accountId":self.accountId,
            "userNo":""+self.userNo,
             "fileUpload": [
                {
                    "type":23,
                    "maxSize":10*1024*1024,
                    "file":this.params.image
                }
            ]
        }).then((response) => {
            if (response.status == 200) {
                const data = response.data.data;
                let fileList = data["file"];
                for(let i=0;i<fileList.length;i++){
                  if(fileList[i].type==23){
                    this.fileId = fileList[i].fileId;
                    break;
                  }
                }

                const paramsData = {
                  userNo: this.params.userNo,
                  enName: this.params.enName,
                  fileId: this.fileId,
                  swiftCode:this.params.swiftCode
                }

                this.$router.push({
                  name: "recipient-summary",
                  params: { data: paramsData },
                });

            }
        }).catch(err => {
            this.isLoading = false;
            this.checkError(err);
        });
      }
      else {
          this.error.image = "can not blank";
      }
    },
    doSubmit() {
      if (this.validate()) {
        this.doUpload();
      }
    },
    onChange(name) {
        this.error[name] = "";
    },
    togglePopup() {
        this.showPopup = !this.showPopup;
    },
    captureFile($event) {
        this.error.image = "";
        this.params.image = $event;
    },
    removeImage($event) {
        this.params.image = "";
        this.error.image = "";
    },
    getMessage: function (key) {
      return this.$t(key);
    },
    checkError(err) {
      this.isLoading = false;
      const response = err.response;
      console.log("===================");
      let self = this;
      if (response.status == 400) {
        console.log(response.data);
        if (typeof response.data.message === "string") {
          this.$swal({
            icon: "info",
            html: response.data.message,
            showConfirmButton: true,
            confirmButtonText: self.getMessage("OK"),
          });
        } else {
          if (response.data.message["errorMsg"]) {
            this.$swal({
              icon: "info",
              html: response.data.message["errorMsg"],
              showConfirmButton: true,
              confirmButtonText: self.getMessage("OK"),
            });
          } else {
            let ret = [];
            Object.keys(response.data.message).forEach((key) => {
              ret.push(response.data.message[key][0]);
            });

            this.$swal({
              icon: "info",
              html: ret.join("<br>"),
              showConfirmButton: true,
              confirmButtonText: self.getMessage("OK"),
            });
          }
        }
      } else if (
        response.status == 401 &&
        response.data.name == "Unauthorized"
      ) {
        localStorage.removeItem("token");
        localStorage.removeItem("member");
        localStorage.removeItem("isFirstTime");
        this.$router.push({
          path: "/login",
        });
      } else {
        if (localStorage.getItem("token")) {
          var msg = response.data ? response.data.message : err.message;
          this.$notify({
            type: "warn",
            text: msg,
          });
        }
      }
    },
  },
  mounted() {
    CreateAccount.listSubAccount({
      start:0,
      length:-1
    }).then((response)=>{
        if (response.status == 200) {
          const data = response.data.data;
          this.accountId = data[0]['accountId'];
          this.userNo = data[0]['userNo'];
        }
    });
  },
};
</script>
